import "@aws-amplify/ui-react/styles.css";
import { Container } from "react-bootstrap";
import "../css/Login.css";
import "../css/ComingSoon.css";
import { connect } from "react-redux";
import { setAuthentication } from "./Store";
import { useAuth } from "./AuthContext";
import React, { useEffect, useState } from "react";
import {
  Authenticator,
  ThemeProvider,
  createTheme,
} from "@aws-amplify/ui-react";
import { useNavigate } from "react-router-dom";

// 👇 NEW: import signUp from Amplify Auth v6
import { signUp } from "aws-amplify/auth";

function Login() {
  const navigate = useNavigate();
  // eslint-disable-next-line no-unused-vars
  const [disclaimerAccepted, setDisclaimerAccepted] = useState(false);
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (isAuthenticated) {
      console.log("✅ Auth ready — redirecting to /progress");
      navigate("/progress", { replace: true });
    }
  }, [isAuthenticated, navigate]);

  // 👇 NEW: capture the original casing at sign-up time
  const services = {
    async handleSignUp(input) {
      // `input` is what Authenticator would normally send to signUp
      const { username, password, options } = input;

      const rawUsername = username; // exactly as user typed it (with case)

      // Call Amplify signUp with the same username/password/options,
      // just adding one extra custom attribute.
      return signUp({
        username: rawUsername, // 🔹 do NOT change this -> same behavior as before
        password,
        options: {
          ...options,
          userAttributes: {
            ...options?.userAttributes,
            "custom:displayName": rawUsername, // 👈 store pretty casing
          },
        },
      });
    },
  };

  // Define a custom theme
  const customTheme = createTheme({
    name: "dark-theme",
    tokens: {
      colors: {
        background: {
          primary: "#272727",
          secondary: "#333333",
        },
        font: {
          primary: { value: "#ffffff" },
          secondary: { value: "#aaaaaa" },
          error: { value: "#ff6b6b" },
        },
        brand: {
          primary: {
            10: "#000000",
            80: "#ffffff",
            100: "#ffffff",
          },
        },
      },
      link: {
        color: { value: "#ffffff" },
        _hover: {
          color: "#daa520",
        },
        _focus: {
          color: "#daa520",
          outline: { value: "none" },
        },
      },
      components: {
        button: {
          primary: {
            backgroundColor: { value: "#000000" },
            color: { value: "#ffffff" },
            borderRadius: { value: "30px" },
            _hover: {
              backgroundColor: { value: "#000000" },
              color: { value: "#daa520" },
            },
          },
        },
        field: {
          label: {
            color: { value: "#ffffff" },
          },
          input: {
            backgroundColor: { value: "#ffffff" },
            borderColor: { value: "#aaaaaa" },
            color: { value: "#000000" },
          },
        },
        tabs: {
          item: {
            color: { value: "#ffffff" },
            _hover: {
              color: "#daa520",
              borderColor: "#daa520",
            },
            _focus: {
              outline: "none",
              borderColor: "#daa520",
            },
            _active: {
              color: "#daa520",
              borderColor: "#daa520",
            },
          },
        },
      },
    },
  });

  return (
    <div className="page">
      <Container fluid>
        <ThemeProvider theme={customTheme}>
          <Authenticator
            className="amplify-authenticator"
            signUpAttributes={["email"]}
            services={services}      // 👈 NEW: plug in our custom sign-up handler
            formFields={{
              signUp: {
                email: {
                  label: "Email",
                  placeholder: "Enter your Email",
                  isRequired: true,
                  order: 1,
                },
                username: {
                  label: "Username",
                  placeholder: "Username (3–20 letters/numbers)",
                  isRequired: true,
                  order: 2,
                },
                password: {
                  label: "Password",
                  placeholder: "Enter your Password",
                  isRequired: true,
                  order: 3,
                },
                confirm_password: {
                  label: "Confirm Password",
                  placeholder: "Please confirm your Password",
                  isRequired: true,
                  order: 4,
                },
                custom_disclaimer: {
                  order: 5,
                  type: "hidden",
                  label: (
                    <>
                      <span
                        className="newuser-small-text"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          flexWrap: "nowrap",
                          whiteSpace: "normal",
                        }}
                      >
                        <input
                          type="checkbox"
                          required
                          style={{ margin: 0, flexShrink: 0 }}
                          onChange={(e) =>
                            setDisclaimerAccepted(e.target.checked)
                          }
                        />
                        <span style={{ display: "inline" }}>
                          I have read and agree with the{" "}
                          <a
                            href="/disclaimer"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="disclaimer-link"
                          >
                            Privacy, Exercise, Content Use, & Terms of Service
                            Disclaimers
                          </a>
                          .
                        </span>
                      </span>
                    </>
                  ),
                  isRequired: false,
                },
              },
            }}
          >
          </Authenticator>
        </ThemeProvider>
      </Container>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    isAuthenticated: state.isAuthenticated,
  };
}

const mapDispatchToProps = {
  setAuthentication,
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
